/**
 * Derive an at-a-glance list of the toggled-on features for a saved template,
 * driven by the report's own settings schema.
 *
 * A template card wants to show "what does this report actually contain" without
 * opening it. That content is exactly the schema's `toggle` fields whose stored
 * setting is truthy: Min/Max, MKT, Time Out of Range, and so on. Reading it from
 * the schema keeps this generic -- every ported report gets the summary from its
 * own field definitions, with no per-report card code.
 *
 * A toggle labelled as an omission ("Hide Graph") reads backwards as an enabled
 * feature, so those are skipped: `summarizeAs: 'omission'` on the field marks a
 * toggle whose ON state removes content rather than adding it.
 *
 * @param {object} schema   A report settings schema (see schemas/excursion.js).
 * @param {object} settings The template's stored report_settings.
 * @returns {string[]} Ordered labels of the enabled, content-adding toggles.
 */
export function enabledFeatureLabels(schema, settings) {
    if (! schema || ! Array.isArray(schema.sections) || ! settings) {
        return []
    }

    const labels = []

    schema.sections.forEach((section) => {
        (section.fields ?? []).forEach((field) => {
            if (field.type !== 'toggle' || field.summarizeAs === 'omission') {
                return
            }

            if (settings[field.key] === true) {
                labels.push(field.chipLabel ?? field.label)
            }
        })
    })

    return labels
}
